<template>
  <template v-if="editionMode">
    <SelectComponent
      v-model="selectedValues"
      :name="name"
      :label="label ?? $t('attributes.supplier')"
      :values="suppliers"
      display-key="name"
      :multiple="multiple"
      :required="required"
      :edition-mode="editionMode"
      :errors="errors"
      :class="$attrs.class"
      :searchable="searchable"
    />
  </template>
  <BaseShowLabel
    v-else
    :label="label ?? $t('attributes.supplier')"
    :model-value="selectedLabel"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

export default {
  name: 'SelectSupplier',
  components: { BaseShowLabel, SelectComponent },
  props: {
    modelValue: {
      type: [Array, Number],
      required: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    errorKey: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: 'supplier'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', { suppliers: 'getSuppliersMetadata' }),
    selectedLabel() {
      return this.suppliers.find((supplier) => supplier.id === this.modelValue)
        ?.name
    }
  }
}
</script>
